import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import ChangePasswordDialog from "@/components/ChangePasswordDialog";
import { Terminal, LogOut } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-50 h-14 bg-background border-b border-border flex items-center justify-between px-4 lg:px-6">
      <div className="flex items-center gap-3">
        <Terminal className="w-5 h-5 text-white" />
        <div className="leading-none">
          <div className="font-mono text-sm tracking-tight text-white">Claude Code Cost Tracker</div>
          <div className="overline">usage &amp; cost telemetry</div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="hidden sm:flex items-center gap-2 font-mono text-xs text-muted-foreground mr-2" data-testid="header-user">
          {user?.email}
          <span className={`px-1.5 py-0.5 border text-[10px] ${user?.role === "admin" ? "border-amber-500/40 text-amber-400" : "border-blue-500/40 text-blue-400"}`}>
            {user?.role}
          </span>
        </span>
        <ChangePasswordDialog />
        <Button
          variant="ghost"
          size="sm"
          onClick={logout}
          data-testid="logout-button"
          className="rounded-none font-mono text-xs hover:bg-secondary gap-2"
        >
          <LogOut className="w-3.5 h-3.5" /> Sign out
        </Button>
      </div>
    </header>
  );
}
